import Slider from '../../../components/slider/Slider'
import styles from './Team.module.css'
import { Col, Row } from 'react-bootstrap'

export default function Team() {
    const path = "./assets/images/"
    const images = [ "car-5.png", "car-4.jpg", "car-6.png" ].map(x => `${path}${x}`)

    return (
        <section>
            <Row className='m-auto align-items-center justify-content-center mt-5 mb-5 pt-5'>
                <h2 className={ `${styles.title} mt-5` }>Meet the <span className={styles.titleItalic}>team</span></h2>
            </Row>
            <Row className='m-auto align-items-center justify-content-center mb-5'>
                <Col
                    xs="12" sm="12" md="12" lg="12"
                    className='p-0 mb-lg-5'
                >
                    <Slider
                        images={ images }
                        buttonContainerClassName={styles.sliderButtonContainer}
                        imageClassName={styles.sliderImage}
                        autoplay
                        autoplayDuration={ 4000 }
                    />
                </Col>
            </Row>
        </section>
    )
}